<template>
    <v-container class="app-footer d-flex justify-center align-center pa-1">
      <v-card-text class="pa-0" style="font-size: 11px;">Abriron Cloud Portal v4.9.6 — 2025</v-card-text>
    </v-container>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.app-footer {
  box-shadow: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #c0c0c07d;
}
</style>
